import { render } from "./form-material.vue?vue&type=template&id=f90e3c6c&ts=true"
import script from "./form-material.vue?vue&type=script&lang=ts"
export * from "./form-material.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__